import { format, parseISO } from 'date-fns'

export function formatDate(date: Date) {
  return format(date, 'd/MMM/yyyy')
}

export function formatTime(date: Date, includeSeconds = false) {
  return format(date, `H:mm${includeSeconds ? ':ss' : ''}`)
}

export function formatDateTime(date: Date, includeSeconds = false) {
  return format(date, `d/MMM/yyyy H:mm${includeSeconds ? ':ss' : ''}`)
}

export function formatIsoDate(isoDate: string) {
  return formatDate(parseISO(isoDate))
}

export function formatIsoTime(isoDate: string) {
  return formatTime(parseISO(isoDate))
}

export function formatIsoDateTime(isoDate: string, includeSeconds = false) {
  return formatDateTime(parseISO(isoDate), includeSeconds)
}

export function formatNativeDateAsIso(date: Date) {
  return format(date, 'yyyy-MM-dd')
}

export function formatIsoDateTimeOffset(isoDate, includeSeconds = false) {
  const [datePart, timePartWithZone] = isoDate.split('T')
  const timePart = includeSeconds
    ? timePartWithZone.split(/[+-]/)[0]
    : timePartWithZone.slice(0, 5)

  return `${datePart} ${timePart}`
}
